import { render, staticRenderFns } from "./bStore_setup_noti.vue?vue&type=template&id=65041812&scoped=true"
import script from "./bStore_setup_noti.vue?vue&type=script&lang=js"
export * from "./bStore_setup_noti.vue?vue&type=script&lang=js"
import style0 from "./bStore_setup_noti.vue?vue&type=style&index=0&id=65041812&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65041812",
  null
  
)

export default component.exports